var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff202d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2027ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191f94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff212e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0d1b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 3.04761905.38095238-.38095238.38095238.38095238v.76190476h-.76190476zm1.52380952 0 .38095238-.38095238.38095238.38095238v.76190476h-.76190476zm1.52380952 0 .38095238-.38095238.38095238.38095238v.76190476h-.76190476z",
    fill: "#1895db",
    mask: "url(#f)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.85714286 3.04761905.38095238-.38095238.38095238.38095238v.76190476h-.76190476zm1.52380952 0 .38095238-.38095238.38095238.38095238v.76190476h-.76190476z",
    fill: "#191f94",
    mask: "url(#f)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.61904762v-3.80952381h16v3.80952381zm9.14285714 0h.76190476l-.20831009.41662019c-.09534773.19069539-.34528457.34528457-.55359467.34528457zm-1.52380952 0h.76190476v.76190476h-.76190476zm-1.52380952 0h.76190476v.76190476c-.21039419 0-.45440384-.14690293-.55359468-.34528457z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 3.80952381h.76190476v.76190476h-.76190476zm1.52380952 0h.38095238l.38095238.76190476h-.76190476zm-2.66666666 0h.38095238v.76190476h-.76190476zm.38095238.76190476h.76190476v.76190476h-.76190476zm1.52380952 0h.76190476v.76190476h-.76190476zm-.76190476.76190476h.76190476v.76190477h-.76190476zm1.52380952 0h.76190476v.76190477h-.76190476zm-.76190476.76190477h.76190476v.76190476h-.76190476zm-2.28571428-.76190477h.76190476v.76190477h-.76190476zm.76190476.76190477h.76190476v.76190476h-.76190476zm-.76190476.76190476h.76190476v.76190476h-.76190476zm1.52380952 0h.76190476v.76190476h-.76190476zm1.52380952 0h.76190476v.76190476h-.76190476zm-.76190476.76190476h.76190476v.76190476h-.76190476zm-1.52380952 0h.76190476v.76190476h-.76190476z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.aa82e441bf57ac80aa3b229bb12d9769.svg";
export { ForwardRef as ReactComponent };